import { compose } from 'redux';
import { WithFetchDatasByIdFromCMSInputProps } from 'modules/shared-cms/hocs';
import { WithFetchDatasByParamsFromCMS } from 'modules/shared-cms-advanced';
import {
    WithNotifyRessourceLoaded,
    WithSessionStorage,
    WithRemoteActions,
    WithStatelessDatasFetching,
    WithNotifyRessourceLoadedInputProps,
} from 'modules/shared/hocs';
import { Session, SessionName, AppointmentType } from 'modules/mariage/models';
import { appointmentService } from 'modules/mariage/services/appointment-service';
import { readPageTitle } from 'modules/shared-cms/utils';
import { AppointmentCreationRemoteActionsProps, AppointmentCreationInjectedProps } from './appointment-creation-type';
import { AppointmentCreationLoader } from './appointment-creation-loader';
import { QUERY } from './appointment-creation-query';

const defaultErrorMessage =
    'Nous rencontrons un problème avec le service de prise de rendez-vous. Merci de réessayer un peu plus tard.';

const enhancer = compose<
    React.ComponentType<WithFetchDatasByIdFromCMSInputProps & WithNotifyRessourceLoadedInputProps>
>(
    WithFetchDatasByParamsFromCMS(AppointmentCreationLoader, QUERY, 'queryLandingAppointmentContents'),
    WithNotifyRessourceLoaded(readPageTitle),
    WithSessionStorage<Session>(SessionName),
    WithRemoteActions<AppointmentCreationRemoteActionsProps>({
        getAvailabilities: {
            action: appointmentService.getAvailabilities,
            errorMessages: [
                {
                    message: "L'identifiant du pro est incorrect",
                    code: 50.151,
                },
            ],
            defaultErrorMessage,
        },
        createAppointment: {
            action: appointmentService.createAppointment,
            errorMessages: [
                {
                    message: 'Limite de rendez-vous atteinte.',
                    code: 50.181,
                },
                {
                    message: "Le créneau n'est plus disponible.",
                    code: 50.182,
                },
            ],
            defaultErrorMessage,
        },
        updateAppointment: {
            action: appointmentService.updateAppointment,
            errorMessages: [
                {
                    message: 'Limite de rendez-vous atteinte.',
                    code: 50.181,
                },
                {
                    message: "Le créneau n'est plus disponible.",
                    code: 50.182,
                },
            ],
            defaultErrorMessage,
        },
        deleteAppointment: {
            action: appointmentService.deleteAppointment,
            defaultErrorMessage,
        },
        getCustomer: {
            action: appointmentService.getCustomer,
            defaultErrorMessage,
        },
    }),
    WithStatelessDatasFetching<AppointmentType[], AppointmentCreationInjectedProps>(
        appointmentService.getAppointmentTypes,
        undefined,
        'error',
        'appointmentTypes',
    ),
);
export default enhancer;
